"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    query getFeaturesService($condition: FeatureCondition) {
        UserProfile {
            features(condition: $condition) {
                nodes {
                    featureId
                    name
                    url
                    type
                }
            }
        }
    }
`;exports.getFeatures=e;
//# sourceMappingURL=queries.js.map
